jQuery(document).ready(function($) {
    if (!window.WebAssessmentCharts) {
        window.WebAssessmentCharts = {}; // Create namespace if it doesn't exist
    }	
	var charts = {};
	let projectID;
	if ($('body').hasClass('single-projects')) {
		// Extract the URL path and split it to get the slug
		const pathParts = window.location.pathname.split('/projects/');
		if (pathParts.length > 1) {
			// Get the slug portion after '/projects/' and remove any trailing slash if present
			projectID = pathParts[1].split('/')[0];
			console.log('Extracted projectID:', projectID); // Verify the extracted project ID
		}
	}
	
	// Now using utility function from fetchProjectChartData.js
	WebAssessmentCharts.fetchProjectChartData = fetchProjectChartData;
	var homeFrameworkProcessUniqueItems = processUniqueItemsCIS;

	// Fetch project data and CRF data, then process them together
	WebAssessmentCharts.fetchDataAndCalculateScores = async function (projectID) {
		// Extract the URL path and split it to get the slug
		const pathParts = window.location.pathname.split('/projects/');
		if (pathParts.length > 1) {
			// Get the slug portion after '/projects/' and remove any trailing slash if present
			projectID = pathParts[1].split('/')[0];
		}

		try {
			// Fetch project data
			const projectData = await WebAssessmentCharts.fetchProjectChartData(projectID);

			// Check if project data is valid
			if (!projectData || !Array.isArray(projectData)) {
				console.error('Project data is missing or not structured as expected:', projectData);
				return;
			}

			// Process project data
			const projectItems = projectData;
			const processedItems = homeFrameworkProcessUniqueItems(projectItems);
			console.log('Processed Items:', processedItems);
			
			// Fetch CIS standards data directly
			try {
				const response = await jQuery.ajax({
					url: controlsData.ajax_url,
					type: 'POST',
					dataType: 'json',
					data: {
						action: 'api_action',
						year: '2024',
						apis: ['CS'],
						CSLstandardID: (WebAssessmentCharts._homeCis71CslOverride || 'CIS-7-1')
					}
				});

				console.log('CIS Standards response structure:', JSON.stringify(response, null, 2));
				// Store the response for use by other functions
				WebAssessmentCharts.cisStandardData = response;
				WebAssessmentCharts.currentCisVersion = (WebAssessmentCharts._homeCis71CslOverride || 'CIS-7-1');

				if (!response.CS || !response.CS.Items) {
					console.error('Invalid CIS standards response structure:', response);
					return;
				}

				// Create a map of control IDs to their priorities
				const controlPriorities = {};
				response.CS.Items.forEach(control => {
					//console.log('Processing control:', control);
					if (control.controlid?.S && control.controlpriority?.S) {
						controlPriorities[control.controlid.S] = control.controlpriority.S;
						//console.log(`Mapped control ${control.controlid.S} to priority ${control.controlpriority.S}`);
					} else {
						console.log('Control missing ID or priority:', control);
					}
				});

				console.log('Control priorities map:', controlPriorities);

				// Add control priorities to processed items
				const itemsWithPriorities = processedItems.map(item => {
					//console.log('Processing item:', item);
					const safeguardId = item.safeguardid.S;
					const priority = controlPriorities[safeguardId];
					if (priority) {
						item.controlpriority = { S: priority };
						console.log(`Added priority ${priority} to safeguard ${safeguardId}`);
					} else {
						console.log(`No priority found for safeguard: ${safeguardId}`);
						console.log('Available control IDs:', Object.keys(controlPriorities));
					}
					return item;
				});

				console.log('Items with priorities:', itemsWithPriorities);
				
				// Now run the CIS71 function with the enhanced data
				WebAssessmentCharts.CIS71(itemsWithPriorities, response);

				// Calculate implementation group scores using the total count from the response
				const igScores = WebAssessmentCharts.calculateImplementationGroupScores(itemsWithPriorities, response.CS.Count, response);
				console.log('Implementation Group Scores:', igScores);

				// The IG mean is the CIS overall maturity (what the gauge shows and the kanban
				// finalize saves). Overwrite the per-control mean CIS71() just set, unrounded,
				// so the project-page finalize posts the same score.
				const igValues = Object.values(igScores).filter(Number.isFinite);
				if (igValues.length) {
					WebAssessmentCharts.overallCIS71maturity = igValues.reduce((sum, score) => sum + score, 0) / igValues.length;
				}

				// Create implementation group chart
				const igTable = document.getElementById('cis7-ig');
				if (igTable) {
					const igRows = igTable.getElementsByTagName('tbody')[0].getElementsByTagName('tr');
					Object.keys(igScores).forEach((ig, index) => {
						if (igRows[index]) {
							igRows[index].cells[1].textContent = igScores[ig].toFixed(2);
						}
					});

					// Calculate and update overall maturity rating for implementation groups
					const igTotal = Object.values(igScores).reduce((sum, score) => sum + score, 0);
					const igAverage = igTotal / Object.keys(igScores).length;
					const igMaturityRow = igTable.querySelector('tfoot .light-background td');
                    $('.audit-overall-value').text(igAverage.toFixed(2));
					$('.cis7-overall-value').text(igAverage.toFixed(2));
					if (igMaturityRow) {
						igMaturityRow.textContent = igAverage.toFixed(2);
					}

					// Create the implementation group chart
					WebAssessmentCharts.createChartFromTable('cis7-ig', 'cis7-ig-chart', charts, true);
				}
			} catch (error) {
				console.error('Error fetching CIS standards:', error);
				// If we fail to get standards data, we can still try to show the CIS71 chart with the data we have
				WebAssessmentCharts.CIS71(processedItems);
			}

		} catch (error) {
			console.error('Error processing data:', error);
		} finally {
			// Always hide the loader, even if an error occurs
			$('.modal-body .loader').hide();
		}
	};

	if (typeof WebAssessmentCharts.registerHomeDashboardFetcher === 'function') {
		var fetchCis71ForHome = WebAssessmentCharts.fetchDataAndCalculateScores;
		WebAssessmentCharts.registerHomeDashboardFetcher('cis-7-1', fetchCis71ForHome);
		WebAssessmentCharts.registerHomeDashboardFetcher('cis-7-0', function (slug) {
			WebAssessmentCharts._homeCis71CslOverride = 'CIS-7-0';
			return Promise.resolve(fetchCis71ForHome.call(WebAssessmentCharts, slug)).finally(function () {
				delete WebAssessmentCharts._homeCis71CslOverride;
			});
		});
	}

	
	// Now using utility function from calculateMaturityScore.js
	WebAssessmentCharts.calculateMaturityScore = calculateMaturityScore;
	
	// Now using utility function from getMostRecentSafeguards.js
	WebAssessmentCharts.getMostRecentSafeguards = getMostRecentSafeguards;
	
	// Now using utility function from processUniqueItemsCIS.js
	WebAssessmentCharts.processUniqueItems = processUniqueItemsCIS;
	
	// Now using utility function from calculateCategoryAverages.js
	var homeFrameworkCalculateCategoryAverages = WebAssessmentCharts.calculateCategoryAverages = calculateCategoryAverages;
	
	WebAssessmentCharts.CIS71 = function(items, cisStandardData) {
		console.log('Starting CIS71 function...');
		const tableBody = document.querySelector('#cis7 tbody');
		if (!tableBody) {
			console.error('CIS 7.1 Table body not found.');
			return;
		}
		
		// Store original row indices before any modifications
		const originalIndices = new Map();
		Array.from(tableBody.rows).forEach((row, index) => {
			originalIndices.set(row, index);
		});

		// Create a map of all possible safeguards from the standard
		const allSafeguards = new Map();
		if (cisStandardData && cisStandardData.CS && cisStandardData.CS.Items) {
			cisStandardData.CS.Items.forEach(control => {
				if (control.controlid && control.controlid.S) {
					allSafeguards.set(control.controlid.S, {
						safeguardid: { S: control.controlid.S },
						policystatus: { N: "0" }, // Default to "Not Answered"
						maturityscore: 0, // Default score for unanswered items
						controlpriority: control.controlpriority // Preserve control priority for IG calculations
					});
				}
			});
		}

		// Merge in any existing answers
		const processedItems = homeFrameworkProcessUniqueItems(items);
		processedItems.forEach(item => {
			allSafeguards.set(item.safeguardid.S, item);
		});

		// Convert back to array
		const mergedItems = Array.from(allSafeguards.values());
		console.log('Merged items (including unanswered):', mergedItems);
		
		// Calculate averages by category
		const averageScores = homeFrameworkCalculateCategoryAverages(mergedItems, cisStandardData);
		
		// Make all rows visible first
		Array.from(tableBody.rows).forEach(row => {
			row.style.display = '';
		});
				
		// Keep track of rows to remove
		const rowsToRemove = [];
		
		// Update the table
		Object.keys(averageScores).forEach(category => {
			const rowIndex = parseInt(category, 10) - 1; // Convert category to table row index
			const row = tableBody.rows[rowIndex];
			if (row) {
				const averageScore = averageScores[category];
				const scoreCell = row.cells[1];
				
				if (averageScore === null) {
					// Only remove rows that are explicitly marked as not applicable
					// (all items in the category have policy status 1)
					rowsToRemove.push(row);
				} else {
					const scaledScore = averageScore * 5; // Scale average score
					scoreCell.textContent = scaledScore.toFixed(2);
					console.log(`Updated row ${rowIndex + 1} with averageScore:`, scaledScore.toFixed(2));
				}
			} else {
				console.warn(`Row not found for category ${category} with rowIndex ${rowIndex}`);
			}
		});
		
		// Remove rows with all null values (all items are Not Applicable)
		rowsToRemove.forEach(row => {
			row.remove();
		});
		
		// Calculate and update overall maturity score
		let totalScore = 0;
		let scoreCount = 0;
		Array.from(tableBody.rows).forEach((row) => {
			const scoreText = row.cells[1].textContent;
			const score = parseFloat(scoreText);
			if (!isNaN(score)) {
				totalScore += score;
				scoreCount++;
			}
		});
		
		const maturityRatingRow = $('#cis7 .light-background td');
		if (maturityRatingRow.length > 0 && scoreCount > 0) {
			const overallMaturity = totalScore / scoreCount;
			WebAssessmentCharts.overallCIS71maturity = overallMaturity;
			
			maturityRatingRow.text(overallMaturity.toFixed(2)); // jQuery method to set text
			
			// For CIS 7.0: No #cis7-ig table exists, so use domain average for overall score
			// For CIS 7.1: #cis7-ig table exists and will be populated by fetchDataAndCalculateScores()
			// which sets .audit-overall-value from the IG average (the correct source for 7.1)
			const igTable = document.getElementById('cis7-ig');
			if (!igTable) {
				// CIS 7.0 - no implementation groups, use domain average
				$('.audit-overall-value').text(overallMaturity.toFixed(2));
				$('.cis7-overall-value').text(overallMaturity.toFixed(2));
				console.log(`CIS 7.0: Updated overall maturity rating to ${overallMaturity.toFixed(2)} (from domain average)`);
			} else {
				console.log(`CIS 7.1: Domain maturity is ${overallMaturity.toFixed(2)}, overall will be set from IG table`);
			}
			
			$('.spinner-border').hide();
			$('.mark-complete-modal-buttons').show();
			
		} else {
			console.error("Error: No scores found or maturity rating row not found in the table.");
		}
		
		applyFrameworkPanelVisibility('show', '.cis7-container');
		WebAssessmentCharts.createChartFromTable('cis7', 'cis7-chart', charts, true);
		
        // Restore original row indices after chart creation
        rowsToRemove.forEach(row => {
            const originalIndex = originalIndices.get(row);
            if (originalIndex !== undefined) {
                tableBody.insertBefore(row, tableBody.rows[originalIndex] || null);
                row.style.display = 'none';
            }
        });
	}
	
	// Now using utility function from chartEventHandlers.js
	initializeChartEventHandlers();

	// Use the modular calculateImplementationGroupScores function
	WebAssessmentCharts.calculateImplementationGroupScores = calculateImplementationGroupScores;

});
